import React from 'react';
import Dependency from '../dependency';
import UsageTable from '../UsageTable';
import PrimaryColors from './PrimaryColors';
import SecondaryColors from './SecondaryColors';
import styles from './color.module.scss';

class Color extends React.Component {
  render() {
    return (
      <section className={styles.section}>
        <header>
          <h1 id="color">Color</h1>
        </header>
        <p>
          Aptitude color rules and styles to be used across all digital Raise Me products. CMYK
          coming soon!
        </p>

        <h2>Dependencies</h2>
        <hr />
        <Dependency identifier="mixins">
          <h3>
            Mixin Usage (e.g. <code className={styles.code}>$b500</code>)
          </h3>
          @import &apos;components/mixins&apos;;
        </Dependency>

        <h2>Primary</h2>
        <p>Raise Me&#39;s core UI colors</p>
        <hr />
        <PrimaryColors />

        <h2>Secondary</h2>
        <p>Raise Me alert notifications and scholarship colors</p>
        <hr />
        <SecondaryColors />

        <h2>Usage</h2>
        <p>Typical usage for every shade of every Raise Me color</p>
        <UsageTable />
      </section>
    );
  }
}

export default Color;
